import sourceChannelManagement from './sourceChannelManagement'

export default {
  systemNotificationManagement: {
    title: 'System Notification',
    menu: 'System Notification'
  },
  jobPosterManagement: {
    title: 'My Post Jobs',
    menu: 'My Post Jobs'
  },
  customerManagement: {
    title: 'Client Admin',
    menu: 'Client Admin'
  },
  adsTierManagement: {
    title: 'Ads Tier Management',
    menu: 'Ads Tier Management'
  },
  pointsManagement: {
    title: 'Points Management',
    menu: 'Points Management'
  },
  cashManagement: {
    title: 'Cash Management',
    menu: 'Cash Management'
  },
  cashOutManagement: {
    title: 'Cash Out Management',
    menu: 'Cash Out Management'
  },
  serviceAccountManagement: {
    title: 'Service Account Management',
    menu: 'Service Account Management'
  },
  uploadDataManagement: {
    title: 'Upload Data',
    menu: 'Upload Data'
  },
  schoolManagement: {
    title: 'School Management',
    menu: 'School Management'
  },
  candidateStatusManagement: {
    title: 'Candidate Status Management',
    menu: 'Candidate Status Management'
  },
  majorManagement: {
    title: 'Major Management',
    menu: 'Major Management'
  },
  exportDataManagement: {
    title: 'Export Data',
    menu: 'Export Data'
  },
  sourceChannelManagement,
  userManagement: {
    title: 'Account Cancellation',
    menu: 'Account Cancellation'
  }
}
